import { createBrowserRouter } from 'react-router';
import NotFoundPage from './NotFoundPage';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/Dashboard/Page';
import InvoicePage from '../pages/Invoice/Page';
import Company from '../pages/Company/Page';
import ReceiptPage from '../pages/Receipt/Page';
import PartnerPage from '../pages/Partner/Page';
import SettingsPage from '../pages/Settings/Page';
import CreateInvoicePage from '../pages/Invoice/Create/Page';
import Service from '../pages/Service/Page';
import Promo from '../pages/Promo/Page';
import Product from '../pages/Product/Page';
import ViewInvoicePage from '../pages/Invoice/View/Page';
import Testimonial from '../pages/Testimonial/Page';
import ViewPartnerPage from '../pages/Partner/View/Page';
import CreateReceiptPage from '../pages/Receipt/Create/Page';
import EditInvoicePage from '../pages/Invoice/Edit/Page';
import Home from '../pages/HomeView/Page';
import ServicePage from '../pages/ServiceView/Page';
import PagePromo from '../pages/PromoView/Page';
import DetailService from '../pages/ServiceView/Detail';
import EditReceiptPage from '../pages/Receipt/Edit/Page';
import ViewReceiptPage from '../pages/Receipt/View/Page';
import DetailTour from '../pages/TourPackageView/Page';
import ContactUsPage from '../pages/ContactUsView/Page';
import AboutUsPage from '../pages/AboutUsView/Page';
import ForgotPassPage from '../pages/ForgotPassPage';
import ResetPassPage from '../pages/ResetPassPage';

export const BASE_URL = '/';
export const SERVICE_PAGE = '/services';
export const PROMO_PAGE = '/deals';
export const CONTACT_PAGE = '/contact-us';
export const ABOUT_PAGE = '/about-us';
export const DETAILSERVICE_PAGE = '/service/:id';
export const DETAILSERVICE_PAGE_NOID = '/service/';
export const DETAILTOUR_PAGE = '/tour/:id';

export const DASHBOARD_PAGE = '/dashboard';
export const SETTING_PAGE = '/settings';
export const LOGIN_PAGE = '/login';
export const FORGOTPASS_PAGE = '/forgot-password';
export const RESETPASS_PAGE = '/reset-password';

// !-- Manage Content --! //
export const COMPANYMANAGE_PAGE = '/company-manage';
export const SERVICEMANAGE_PAGE = '/service-manage';
export const PROMOMANAGE_PAGE = '/promo-manage';
export const PRODUCTMANAGE_PAGE = '/product-manage';
export const TESTIMANAGE_PAGE = '/testimonial-manage';

// !-- Sales --! //
export const INVOICE_PAGE = '/invoice';
export const INVOICECREATE_PAGE = '/invoice/create';
export const INVOICEVIEW_PAGE = '/invoice/view/:invoiceId';
export const INVOICEEDIT_PAGE = '/invoice/edit/:invoiceId';
export const RECEIPT_PAGE = '/receipt';
export const RECEIPTCREATE_PAGE = '/receipt/create';
export const RECEIPTVIEW_PAGE = '/receipt/view/:receiptId';
export const RECEIPTEDIT_PAGE = '/receipt/edit/:receiptId';
export const PARTNER_PAGE = '/partner';
export const PARTNERVIEW_PAGE = '/partner/view/:partnerId';

export const router = createBrowserRouter([
  {
    path: BASE_URL,
    Component: Home,
  },

  {
    path: '*',
    Component: NotFoundPage,
  },
  {
    path: FORGOTPASS_PAGE,
    Component: ForgotPassPage,
  },
  {
    path: RESETPASS_PAGE,
    Component: ResetPassPage,
  },

  {
    path: SERVICE_PAGE,
    Component: ServicePage,
  },

  {
    path: CONTACT_PAGE,
    Component: ContactUsPage,
  },

  {
    path: ABOUT_PAGE,
    Component: AboutUsPage,
  },

  {
    path: DETAILTOUR_PAGE,
    Component: DetailTour,
  },

  {
    path: DETAILSERVICE_PAGE,
    Component: DetailService,
  },

  {
    path: DETAILSERVICE_PAGE_NOID,
    Component: DetailService,
  },

  {
    path: PROMO_PAGE,
    Component: PagePromo,
  },

  // dashboard
  {
    path: DASHBOARD_PAGE,
    Component: DashboardPage,
  },

  // settings
  {
    path: SETTING_PAGE,
    Component: SettingsPage,
  },

  // authentication
  {
    path: LOGIN_PAGE,
    Component: LoginPage,
  },

  // !-- Content Management Route --! //
  // company
  {
    path: COMPANYMANAGE_PAGE,
    Component: Company,
  },
  // service
  {
    path: SERVICEMANAGE_PAGE,
    Component: Service,
  },
  // promo
  {
    path: PROMOMANAGE_PAGE,
    Component: Promo,
  },
  // product
  {
    path: PRODUCTMANAGE_PAGE,
    Component: Product,
  },
  // Testimonial
  {
    path: TESTIMANAGE_PAGE,
    Component: Testimonial,
  },

  // !-- Sales Route --! //
  // invoice
  {
    path: INVOICE_PAGE,
    Component: InvoicePage,
  },
  {
    path: INVOICECREATE_PAGE,
    Component: CreateInvoicePage,
  },
  {
    path: INVOICEVIEW_PAGE,
    Component: ViewInvoicePage,
  },
  {
    path: INVOICEEDIT_PAGE,
    Component: EditInvoicePage,
  },

  // receipt
  {
    path: RECEIPT_PAGE,
    Component: ReceiptPage,
  },
  {
    path: RECEIPTCREATE_PAGE,
    Component: CreateReceiptPage,
  },
  {
    path: RECEIPTVIEW_PAGE,
    Component: ViewReceiptPage,
  },
  {
    path: RECEIPTEDIT_PAGE,
    Component: EditReceiptPage,
  },

  // partner
  {
    path: PARTNER_PAGE,
    Component: PartnerPage,
  },
  {
    path: PARTNERVIEW_PAGE,
    Component: ViewPartnerPage,
  },
]);
